import styled from 'styled-components';

const ToolbarLeft = styled.div({
  display: 'flex',
  flex: '1 1 auto',
});

export { ToolbarLeft };
